/**
 * @param text text to strip special characters
 */
export function stripSpecialCharacters(text: string) {
  return text.replace(/[^a-zA-Z-]*/g, '');
}

export function uuidFromURL(url: string) {
    const matches = (/\/share\/([1-9a-zA-Z]*)\//).exec(url);
    return matches && matches.length > 1 ? matches[1] : null;
}

/**
 * Sanitizes a uuid to remove malicious characters.
 * @param uuid The passed in uuid
 */
export function sanitizeUUID(uuid: string): string {
    return uuid.replace(/[^1-9a-zA-Z]/g, '');
}
